module.exports = __webpack_public_path__ + "media/images/cropper-fulltext-98f1626ad085654db349d3172aa1b3c3.png";